const MoreInfoModal = ({ infoVehicle }) => {
    const { vehicle, images, engines, kbaNumbers } = infoVehicle;

    const infoItems = [
        vehicle?.id && (
            <p key="id">
                ID: <span>{vehicle.id}</span>
            </p>
        ),
        vehicle?.manufacturer_id && (
            <p key="manufacturer_id">
                Marca ID: <span>{vehicle.manufacturer_id}</span>
            </p>
        ),
        vehicle?.manufacturer_name && (
            <p key="manufacturer_name">
                Marca: <span>{vehicle.manufacturer_name}</span>
            </p>
        ),
        vehicle?.model_series_id && (
            <p key="model_series_id">
                Modelo ID: <span>{vehicle.model_series_id}</span>
            </p>
        ),
        vehicle?.model_series_name && (
            <p key="model_series_name">
                Modelo: <span>{vehicle.model_series_name}</span>
            </p>
        ),
        vehicle?.description && (
            <p key="description">
                Descripción: <span>{vehicle.description}</span>
            </p>
        ),
        vehicle?.begin_year_month && (
            <p key="begin_year_month">
                Fecha inicio producción: <span>{vehicle.begin_year_month}</span>
            </p>
        ),
        vehicle?.end_year_month && (
            <p key="end_year_month">
                Fecha fin producción: <span>{vehicle.end_year_month}</span>
            </p>
        ),
        vehicle?.drive_type && (
            <p key="drive_type">
                Tipo de tracción: <span>{vehicle.drive_type}</span>
            </p>
        ),
        vehicle?.body_style && (
            <p key="body_style">
                Tipo de carrocería: <span>{vehicle.body_style}</span>
            </p>
        ),
        vehicle?.fuel_mixture_formation_type && (
            <p key="fuel_mixture_formation_type">
                Tipo de inyección:{' '}
                <span>{vehicle.fuel_mixture_formation_type}</span>
            </p>
        ),
        vehicle?.fuel_type && (
            <p key="fuel_type">
                Tipo de combustible: <span>{vehicle.fuel_type}</span>
            </p>
        ),
        vehicle?.engine_type && (
            <p key="engine_type">
                Tipo de motor: <span>{vehicle.engine_type}</span>
            </p>
        ),
        vehicle?.horse_power_from && (
            <p key="horse_power_from">
                Potencia mínima (HP): <span>{vehicle.horse_power_from}</span>
            </p>
        ),
        vehicle?.horse_power_to && (
            <p key="horse_power_to">
                Potencia máxima (HP): <span>{vehicle.horse_power_to}</span>
            </p>
        ),
        vehicle?.kilo_watts_from && (
            <p key="kilo_watts_from">
                Potencia mínima (kW): <span>{vehicle.kilo_watts_from}</span>
            </p>
        ),
        vehicle?.kilo_watts_to && (
            <p key="kilo_watts_to">
                Potencia máxima (kW): <span>{vehicle.kilo_watts_to}</span>
            </p>
        ),
        vehicle?.cylinders && (
            <p key="cylinders">
                Número de cilindros: <span>{vehicle.cylinders}</span>
            </p>
        ),
        vehicle?.capacity_cc && (
            <p key="capacity_cc">
                Cilindrada (cc): <span>{vehicle.capacity_cc}</span>
            </p>
        ),
        vehicle?.capacity_liters && (
            <p key="capacity_liters">
                Cilindrada (L): <span>{vehicle.capacity_liters}</span>
            </p>
        ),
        engines?.length > 0 && (
            <p key="engines">
                Motores:{' '}
                <span>
                    {engines.map((e, idx) =>
                        idx === 0 ? e.code : `, ${e.code}`
                    )}
                </span>
            </p>
        ),
        kbaNumbers?.length > 0 && (
            <p key="kbaNumbers">
                Números KBA:{' '}
                <span>
                    {kbaNumbers.map((k, idx) =>
                        idx === 0 ? k.kba_number : `, ${k.kba_number}`
                    )}
                </span>
            </p>
        ),
    ].filter(Boolean);

    const mitad = Math.ceil(infoItems.length / 2);
    const firstColumn = infoItems.slice(0, mitad);
    const secondColumn = infoItems.slice(mitad);

    return (
        <div className="more-info-modal">
            <div className="more-info-modal__info-columns">
                <div className="column">{firstColumn}</div>
                <div className="column">{secondColumn}</div>
            </div>

            {images?.length > 0 && (
                <div className="more-info-modal__images">
                    {images.map((img) => (
                        <div key={img.id}>
                            <img src={img?.image_url_800} alt={img?.id} />
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MoreInfoModal;
